import { render, staticRenderFns } from "./StoneFooter.vue?vue&type=template&id=4cbbb6de&scoped=true&"
import script from "./StoneFooter.vue?vue&type=script&lang=js&"
export * from "./StoneFooter.vue?vue&type=script&lang=js&"
import style0 from "./StoneFooter.vue?vue&type=style&index=0&id=4cbbb6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbbb6de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFooter,VImg,VSheet,VSpacer})
